module.exports = __webpack_public_path__ + "img/Weapon_17.4050419c.png";